module.exports = __webpack_public_path__ + "pc/img/career-swiper01.0029f8d4.png";